import { combineReducers } from "redux";

const byId = (state = {}, action) => {
  switch (action.type) {
    case "ADD_MOSAIC_TILES":
      return {
        ...state,
        ...action.files.reduce((obj, file) => {
          obj[file.id] = {
            id: file.id,
            name: file.name,
            pending: true,
            error: false
          };
          return obj;
        }, {})
      };
    case "MOSAIC_TILE_CACHED": {
      const newState = { ...state };
      const { id } = action;
      if (typeof newState[id] === "undefined") return state;
      newState[id].pending = false;
      return newState;
    }
    case "ADD_MOSAIC_TILE_ERROR": {
      const newState = { ...state };
      const { id } = action;
      newState[id].error = true;
      newState[id].pending = false;
      return newState;
    }
    case "REMOVE_MOSAIC_TILE": {
      const newState = { ...state };
      delete newState[action.id];
      return newState;
    }
    case "CLEAR_MOSAIC_TILES_SUCCESS": {
      return {};
    }
    default:
      return state;
  }
};

const count = (state = 0, action) => {
  switch (action.type) {
    case "ADD_MOSAIC_TILES":
      return state + action.files.length;
    case "REMOVE_MOSAIC_TILE":
      return state - 1;
    case "CLEAR_MOSAIC_TILES_SUCCESS":
      return 0;
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case "CLEAR_MOSAIC_TILES":
    case "START_ADDING_TILES":
      return true;
    case "CLEAR_MOSAIC_TILES_SUCCESS":
    case "ADD_MOSAIC_TILES":
      return false;
    default:
      return state;
  }
};

export const filter = (state = "", action) => {
  switch (action.type) {
    case "UPDATE_MOSAIC_TILES_FILTER":
      return action.filter;
    case "RESET_MOSAIC_TILES_FILER":
      return "";
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  count,
  loading,
  filter
});

export const filtered = ({ byId, filter }) =>
  Object.keys(byId)
    .map(id => byId[id])
    .filter(t => {
      const trimmed = filter.trim();
      //all
      if (trimmed.length === 0) return true;
      return t.name.includes(filter);
    });



// WEBPACK FOOTER //
// ./src/reducers/mosaic/tiles.js